/**
 * Функции которые устанавливают цвет для гридов
 * */

const YES_NO_UNKNOWN_COLORS: Array<{ values: string[]; color: string }> = [
    { values: ['Да', 'Yes'], color: 'rgb(144, 238, 144)' },
    { values: ['Нет', 'No'], color: 'rgb(255, 192, 203)' },
    { values: ['Неизвестно', 'Не требуется', 'Unknown', 'Not required'], color: 'rgb(255, 255, 0)' }
];

function setColorsTdYesNo() {
    $('.k-grid').each((_, element) => {
        const grid = $(element).data('kendoGrid');

        if (grid) {
            colorCells(grid);
            return;
        }

        const treeList = $(element).data('kendoTreeList');
        colorCells(treeList);
    });
}

function colorCells(control?: kendo.ui.Grid | kendo.ui.TreeList) {
    if (control) {
        const setColorHandler = () => {
            queueMicrotask(() => {
                window.setColorCellsWithValueYesNoUnknown(control);
            });
        };

        control.bind('dataBound', setColorHandler);
        control.bind('edit', () => {
            $('.k-grid-cancel').on('click', setColorHandler);
            $('.k-window-action').on('click', setColorHandler);
        });
    }
}

function setColorCellsWithValueYesNoUnknown(instance: kendo.ui.Grid | kendo.ui.TreeList) {
    const cellsForColoring = instance.element.find('td:not([data-disable-default-coloring-yes-no-unknown])');
    cellsForColoring.each((_, td) => {
        const value = td.textContent.trim();
        const match = Object.values(YES_NO_UNKNOWN_COLORS).find((x) => x.values.includes(value));

        if (match) {
            td.style.backgroundColor = match.color;
        }
    });
}

window.setColorCellsWithValueYesNoUnknown = setColorCellsWithValueYesNoUnknown;
window.colorCells = colorCells;
window.setColorsTdYesNo = setColorsTdYesNo;
